"use client";
import { Stack } from "@mui/material";

import { useStore, observer } from "../../../../../../service/mobx";
import FilterChips from "../../../../../../component/Chip/Filter";

function FilterRelated({ tab }) {
  const { analytics, reader } = useStore();

  return (
    <Stack useFlexGap direction="row" flexWrap="wrap" spacing={1}>
      {reader.relatedTabs.map(([label, url]) => (
        <FilterChips
          key={label}
          label={label}
          selected={tab === url}
          href={tab === url ? "paper" : url}
          onClick={() => {
            analytics.track.event("Related Filter", {
              type: label,
              value: url
            });
          }}
        />
      ))}
    </Stack>
  );
}

export default observer(FilterRelated);
